import React, { useState,useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import TableRowstoshow from './_tables-rows';   
import Pagination from "@material-ui/lab/Pagination";
import moment from "moment";
import { Hidden, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { cssuseStyles } from '../../e_billing-style';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 1700,
    justifyContent:"center",
    padding:"0 10px"
    
  },
  smcontainer: {
    maxHeight: 1700,
    justifyContent:"center",
  },
  table:{
   whiteSpace:"nowrap !important",
    width:"99.5%",
    ['@media (max-width:600px)']: {
      "& .MuiTableCell-root ":{
        padding:"10px"
      }
      },
  },
  padding:{
    ['@media (min-width:600px)']: {
      "& .MuiTableCell-root ":{
        paddingLeft:"8%"
      }
      },
  },
  paginationColor:{
    display: "flex",
    justifyContent: "center",
    marginBottom:"4px",
    "& .MuiPaginationItem-root": {
      color:theme.palette.ePrimary?.base + "!important",
      margin:"0px"
    },
    "& .Mui-selected":{
      backgroundColor:theme.palette.ePrimary?.base + "!important",
      color:theme.palette.eWhite?.base+" !important"
    },
    
  },
  padding3:{
    paddingLeft:"2%"
  },
  marginT:{
    marginTop:"5%"
  }
}));

export default function TableData({data,tabName}) {
  const classes = cssuseStyles();
  const [apiData , setApiData] = useState(data)
  const useStyleClasses = useStyles();
  const [page, setPage] = useState(1);
  useEffect(() => {
    setPage(1);
  }, [data])
  const y = useSelector( (state) => state?.parametersWidgets?.ParameterLookup?.ROWS_PER_PAGE_CHARGES_AND_PAYMENTS);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const { t: labels, ready: labelsReady } = useTranslation("label-E_BILLS_CHARGES_AND_PAYMENTS");
  const { t: billLabels, ready: billLabelsReady } = useTranslation("label-E_PAYMENT_RECEIPT");
  // let labels = useSelector(
  //   (state) => state?.labels?.data?.getLabels?.E_BILLS_CHARGES_AND_PAYMENTS
  // );
  const [tablePageCount, setTablePageCount] = useState(Math.ceil((data.length/rowsPerPage)));
  const [sortByAmount, setSortByAmount] = useState(0);
  const [sortByDate, setSortByDate] = useState(1);
  const [orderby, setOrderBy] = useState(1);  //1 for date and 0 for amount
  const [collapseRows, setcollapseRows] = useState(0);
  let isPrepaidSa = useSelector((store) => store?.meterDetails?.getSaInfo?.isPrepaidSa);
    isPrepaidSa = isPrepaidSa === "Y" ? true : false;
    const [isPrepaid, setIsPrepaid] = useState();
    useEffect(()=>{
      if(isPrepaidSa !== isPrepaid){
        setIsPrepaid(isPrepaidSa);
      }
    },[isPrepaidSa])
    const sortByDateAndAmount = (data) => {
      if(orderby == 1){
        if(sortByDate){
          data = data.sort((a, b) => {
            if(moment(a.date.substring(0, 10)).isBefore(b.date.substring(0, 10))){
              return 1;
            }
            else{
              return -1;
            }
          });
      }
      else{
          data = data.sort((a, b) => {
            if(moment(a.date.substring(0, 10)).isBefore(b.date.substring(0, 10))){
              return 1;
            }
            else{
              return -1;
            }
          }).reverse();
      }
      }
      else if(orderby == 0){
        if(sortByAmount){
          data = data.sort((a, b) => parseFloat(a.amount) - parseFloat(b.amount));
      }
      else{
          data = data.sort((a, b) => parseFloat(a.amount) - parseFloat(b.amount)).reverse();
      }
      }
      else{
        data = data.sort((a, b) => {
          if(moment(b.date.substring(0, 10)).isBefore(a.date.substring(0, 10))){
            return 1;
          }
          else{
            return -1;
          }
        });
      }
      return data;
    }
  data = sortByDateAndAmount(data);

  if(Math.ceil((data.length/rowsPerPage)) !== tablePageCount){
    setTablePageCount(Math.ceil((data.length/rowsPerPage)));
  }
  const handlePageChange = (event, newpage) => {
    setPage(newpage);
  };
  const updateRowData = () =>{
      return data.slice((page-1)*rowsPerPage,(page)*rowsPerPage);
  }
  data=updateRowData();
  const handleSortByAmount = ()=>{
    sortByAmount?setSortByAmount(0):setSortByAmount(1);
      setOrderBy(0);
      setcollapseRows(prev => prev + 1);
  }
  const handleSortByDate = ()=>{
      sortByDate?setSortByDate(0):setSortByDate(1);
      setOrderBy(1);
      setcollapseRows(prev => prev + 1);
  }
  //orderby variable represent 0 for order by amount and 1 for orderbydate
  const [currency,setCurrency] = useState(apiData?.[0]?.currency);
  const EDGE_CURRENCY_SYMBOL= "BDT";
  let currencyCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE);
  useEffect(() => {
    if(apiData?.[0]?.currency) {
      setCurrency(apiData?.[0]?.currency && apiData?.[0]?.currency==EDGE_CURRENCY_SYMBOL?currencyCode:apiData?.[0]?.currency);
    }
  }, [apiData?.[0]?.currency, currencyCode]);
//   let billLabels = useSelector(
//     (state) => state?.labels?.data?.getLabels?.E_PAYMENT_RECEIPT
// );
  return (
    <>
        {data.length === 0 ? (
        <Typography
        variant="h6"
        
        align="center"
        className={useStyleClasses.marginT}
      >
       {labels("E_NO_DATA_AVAILABE")}
      </Typography>
        ):(
        <div>
        <Paper className={useStyleClasses.root} elevation={0}>
        <Hidden xsDown>
        <TableContainer className={useStyleClasses.container}>
          <Table className={useStyleClasses.table}>
            <TableHead>
              <TableRow size="small">
                <TableCell className={`${classes.tableHead} ${useStyleClasses.padding3}`} onClick={handleSortByDate}>
                <b>{labelsReady?labels("E_TABLE_HEADER_DATE"):""} <UnfoldMoreIcon/></b>
                </TableCell>
                {(isPrepaid) ? <TableCell  className={classes.tableHead}>
                <b>{labels("E_TABLE_HEADER_SUMMARY")}</b>
                </TableCell> : 
                <TableCell  className={classes.tableHead}>
                    <b>{billLabels("E_PAYMENT_BILL_STATUS")}</b>
                </TableCell>}
                <TableCell  className={classes.tableHead}>
                    <b>{billLabels("E_USAGE_KWH")}</b>
                </TableCell>
                <TableCell colSpan={2} className={`${classes.tableHead} ${useStyleClasses.padding3}`} onClick={handleSortByAmount}>
                <b>{labels("E_TABLE_HEADER_AMOUNT")}({currency}) <UnfoldMoreIcon/></b>
                </TableCell>
              </TableRow> 
            </TableHead>
            <TableBody> 
              {
              data?.map((row)=>(
                  <TableRowstoshow key={isPrepaid ? row?.txnId: row.billId} row={row} tabName={tabName} collapseRows={collapseRows}/>
              ))}
          </TableBody>
          </Table>
        </TableContainer>
        </Hidden>

        <Hidden smUp>
        <Table aria-label="collapsible table">
        <TableContainer className={useStyleClasses.smcontainer}>
          <Table className={useStyleClasses.table}>
            <TableHead>
              <TableRow >
                <TableCell onClick={handleSortByDate}>
                <b>{labels("E_TABLE_HEADER_DATE")} <UnfoldMoreIcon/></b>
                </TableCell>
                {(isPrepaid) ? <TableCell align="center" >
                <b>{labels("E_TABLE_HEADER_SUMMARY")}</b>
                </TableCell> : 
                <TableCell >
                    <b>{billLabels("E_PAYMENT_BILL_STATUS")}</b>
                </TableCell>}
                <TableCell align="center"  >
                <b>{billLabels("E_USAGE_KWH")}</b>
                </TableCell>
                <TableCell onClick={handleSortByAmount} >
                <b>{labels("E_TABLE_HEADER_AMOUNT")}({currency}) <UnfoldMoreIcon/></b>
                </TableCell>
              </TableRow> 
            </TableHead>
            </Table>
            </TableContainer>
            <TableBody>
              {
              data?.map((row)=>(
                  <TableRowstoshow key={isPrepaid ? row?.txnId: row.billId} row={row} tabName={tabName} collapseRows={collapseRows}/>
              ))}
              </TableBody>
                </Table>
        </Hidden>
        {(tablePageCount > 1) && (<Pagination
                  count={tablePageCount}
                  page={page}
                  onChange={handlePageChange}
                  className={useStyleClasses.paginationColor}
                  siblingCount={0}
                />
        )}
      </Paper>
        </div>
        )}
    </>
  );
}